import React from "react";
import { CellRenderers } from "utils/tableUtils";

interface RichTextRendererProps {
  content?: string;
  style?: React.CSSProperties;
}

const decodeHtmlEntities = (html: string): string => {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = html;
  return textarea.value;
};

export const RichTextRenderer: React.FC<RichTextRendererProps> = ({
  content,
  style,
}) => {
  if (!content) {
    return CellRenderers.VALUE_OR_NA(content);
  }

  const processedContent = content.replace(/</g, "&lt;").replace(/>/g, "&gt;");

  return (
    <span
      className="text-ellipsis"
      style={style}
      title={decodeHtmlEntities(processedContent)}
      dangerouslySetInnerHTML={{ __html: processedContent }}
    />
  );
};
